import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content", "focus"]

  show(event) {
    event.preventDefault()
    if (this.hasTriggerTarget) {
      this.triggerTarget.classList.add("hidden")
    } else {
      event.currentTarget.classList.add("hidden")
    }
    this.contentTarget.classList.remove("hidden")
    if (this.hasFocusTarget) this.focusTarget.focus()
  }

  hide(event) {
    event.preventDefault()
    this.contentTarget.classList.add("hidden")
    if (this.hasTriggerTarget) this.triggerTarget.classList.remove("hidden")
  }
}
